import { Bitmap, Color, MovieClip, TextFormat } from "../runtime";
import { G_messageBox } from "./assets";
import { FONT_BODY, TEXT_COLOURS, createTextField } from "./textStyle";

/**
 * Centre-screen banner ("BARRIERS DOWN" and friends) that drifts upwards on a
 * decaying speed, strobes white three times, then fades out. Any message other
 * than the default gets the shorter, faster set of timings.
 */
export class MessageBox extends MovieClip {
  private readonly speedMult: number;
  private readonly lifeLimit: number;
  private readonly fadeRate: number;
  private life = 0;
  private alphaCurrent = 0;
  private fading = false;
  private speedCurrent = 4.75;
  private flashLimit = 3;
  private flashCounter = 0;

  constructor(msg = "BARRIERS DOWN") {
    super();
    const format = new TextFormat();
    this.x = 360;
    this.y = 180;
    if (msg !== "BARRIERS DOWN") {
      this.lifeLimit = 28;
      this.speedMult = 0.08;
      this.fadeRate = 10;
    } else {
      this.lifeLimit = 90;
      this.speedMult = 0.09;
      this.fadeRate = 3;
    }
    const boxSpr = new Bitmap(new G_messageBox());
    boxSpr.x = boxSpr.width * -0.5;
    boxSpr.y = boxSpr.height * -0.5;
    boxSpr.alpha = 0.75;
    this.addChild(boxSpr);
    const textHolder = new MovieClip();
    this.addChild(textHolder);
    format.align = "center";
    format.bold = true;
    format.font = FONT_BODY;
    format.color = TEXT_COLOURS.aqua;
    format.size = 18;
    createTextField(textHolder, format, {
      width: 200,
      height: 30,
      centerX: true,
      y: -19,
      text: msg,
    });
    textHolder.scaleX = 0.8;
  }

  /** 1 once the banner has faded out, undefined while it is still on screen. */
  update(): number | undefined {
    ++this.life;
    if (this.life === this.lifeLimit) {
      this.fading = true;
    }
    if (this.flashLimit > 0) {
      ++this.flashCounter;
      if (this.flashCounter === 1) {
        const c = new Color();
        c.setTint(16777215, 1);
        this.transform.colorTransform = c;
      }
      if (this.flashCounter === 5) {
        const c2 = new Color();
        c2.setTint(16777215, 0);
        this.transform.colorTransform = c2;
      }
      if (this.flashCounter === 8) {
        this.flashCounter = 0;
        --this.flashLimit;
      }
    }
    this.speedCurrent += (0 - this.speedCurrent) * this.speedMult;
    this.y -= this.speedCurrent;
    if (this.fading) {
      this.alphaCurrent -= this.fadeRate;
      if (this.alphaCurrent < 0) {
        this.alphaCurrent = 0;
      }
      this.alpha = this.alphaCurrent * 0.01;
      if (this.alphaCurrent === 0) {
        return 1;
      }
    } else if (this.alphaCurrent < 100) {
      this.alphaCurrent += 20;
      this.alpha = this.alphaCurrent * 0.01;
    }
  }
}
